import React from "react";
import PdfBase from "./PdfBase";
import { generateSharedBasedPaymentPdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const SharedBasedPaymentPdf = ({
  schedule,
  company,
  data,
  calculationResults,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [
    schedule,
    company,
    data,
    calculationResults,
    notes,
    reviewNotes,
  ];

  return (
    <>
      <PdfBase
        company={company}
        enableDraftView
        generatePdf={(forView) =>
          generateSharedBasedPaymentPdf(forView, ...sharedArgs)
        }
        downloadName="Share-Based Payment Schedule"
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateSharedBasedPaymentPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default SharedBasedPaymentPdf;
